import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {FORGOT_PASSWORD_RESET} from "../../../services/PageUtils";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";

interface Props {

}

const ForgotPasswordEmailConfirmation = ({}: Props) => {

    const navigate = useNavigate();
    const { deleteCredentials } = CredentialsService();

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email is required")
    });

    useEffect(() => {
        setLoading(false);
    }, []);

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined)
        let resp = await deleteCredentials(values.email);
        setLoading(false);
        if (resp.error) {
            setErrMsg(resp.error.message);
            return;
        }
        navigate(FORGOT_PASSWORD_RESET, {
            state: {
                email: values.email
            },
        })
    };

    return (
        <FormContainer>
            <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <div>
                <span className={"heading"}>Forgot Password</span>
            </div>

            <div>
                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <form onSubmit={handleSubmit}>
                            <h3 className={"onboarding_labelWithExplanation"}>Email</h3>
                            <span className={"onboarding_explanation"}>
                                Please enter your email address so we can send you a confirmation code.
                            </span>
                            <div style={{ marginTop: '0.25em' }}>
                                <input
                                    required
                                    className="onboarding_input"
                                    type="email"
                                    name="email"
                                    placeholder="Email address"
                                    value={values.email}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                />
                                {touched.email && errors.email && (
                                    <ErrorBox text={errors.email} />
                                )}
                            </div>

                            <ErrorBox text={errMsg} />

                            <div style={{ marginTop: '1.5em' }}>
                                <Button text={"CONFIRM EMAIL"} type="submit" disabled={loading} />
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </FormContainer>
    )
}

export default ForgotPasswordEmailConfirmation;